<script setup>
import { computed, ref } from "vue";
import InfiniteArticleList from "./components/ArticleList/InfiniteArticleList.vue";
import { useResultsStore } from "./stores/results";

const resultsStore = useResultsStore();

const isReloading = ref(true);

const props = defineProps({
  person: {
    type: Number,
    required: true,
  },
});

const filters = computed(() => {
  return {
    persons: [props.person],
  };
});

async function init() {
  await resultsStore.fetchResults(filters.value);
  isReloading.value = false;
}

init();
</script>

<template>
  <InfiniteArticleList class="container" :filters="filters" :is-reloading="isReloading" />
</template>

